import { AppService } from "./app-service/app.service";
import { BookingsServices } from "./bookings/bookings-service";
import { BookingActivityLogsServices } from "./booking-activity-logs/booking-activity-logs.service";
import { BookingDiscussionItemsServices } from "./booking-discussion-items/booking-discussion-items.service";
import { CRMService } from "./crm/crm.service";
import { DangerousDeletionServices } from "./dangerous-deletion/dangerous-deletion.service";
import { SDKConfig } from "./default-sdk-config";
import { ExternalAccountsServices } from "./external-accounts/external-accounts.service";
import { FilesService } from "./file-management/file-management.service";
import { HolidayQuotesXServices } from "./holiday-quotes-x/holiday-quotes-x.service";
import { QuoteTemplatesServices } from "./quote-templates/quote-templates.service";
import { HolidayQuotesServices } from "./holiday-quotes/holiday-quotes.service";
import { BookingTransactionsServices } from "./booking-transactions/booking-transactions.service";
import { LedgersServices } from "./ledgers/ledgers.service";
import { LedgerTransactionsServices } from "./ledger-transactions/ledger-transactions.service";
import { JournalEntriesServices } from "./journal-entries/journal-entries.service";
import { TrialBalanceServices } from "./trial-balance/trial-balance.service";
import { TradeExpensesServices } from "./trade-expenses/trade-expenses.service";
import { CustomerInvoicesServices } from "./customer-invoices/customer-invoices.service";
import { CustomerPaymentReceiptsServices } from "./customer-payment-receipts/customer-payment-receipts.service";
import { CustomerCreditVouchersServices } from "./customer-credit-vouchers/customer-credit-vouchers.service";
import { ProfitAllocationRecordsServices } from "./profit-allocation-records/profit-allocation-records.service";
import { SupplierBillsServices } from "./supplier-bills/supplier-bills.service";
import { SupplierBillPaymentReceiptsServices } from "./supplier-bill-payment-receipts/supplier-bill-payment-receipts.service";
import { SuppliersServices } from "./suppliers/suppliers.service";
import { CustomerPaymentMethodsServices } from "./customer-payment-methods/customer-payment-methods.service";
import { SupplierPaymentMethodsServices } from "./supplier-payment-methods/supplier-payment-methods.service";
import { MailchimpServices } from "./mailchimp/mailchimp.service";
import { ResendEmailsConfigurationsServices } from "./resend-emails-configurations/resend-emails-configurations.service";
import { MainService } from "./main.service";
import { NotificationInboxServices } from "./notification-inbox/notification-inbox.service";
import { NotificationsServices } from "./notifications/notifications.service";
import { ReportsServices } from "./reports/reports.service";
import { PerformanceReportServices } from "./reports/performance-report.service";
import { AtolReportServices } from "./reports/atol-report.service";
import { ScheduledReportsService } from "./scheduled-reports/scheduled-reports.service";
import { SyncServerServices } from "./sync-server/sync-server.service";
import { BrandServices } from "./brands/brands.service";
import { TasksServices } from "./tasks/tasks.service";
import { BillingServices } from "./user-management/billing.service";
import { AccountsAndUserManagementServices } from "./user-management/user-management.service";
import { AccountAuditLogsServices } from "./account-audit-logs/account-audit-logs.service";
import { AccountingBulkOperationsServices } from "./accounting-bulk-operations/accounting-bulk-operations.service";
import { FlightSearchServices } from "./flight-search/flight-search.service";
import { ReconciliationServices } from "./reconciliation/reconciliation.service";
import { AccountingFlagsServices } from "./accounting-flags/accounting-flags.service";

export type iSDK = AccountsAndUserManagementServices &
  CRMService &
  AppService &
  FilesService &
  BillingServices &
  SyncServerServices &
  ReportsServices &
  PerformanceReportServices &
  AtolReportServices &
  ScheduledReportsService &
  TasksServices &
  MailchimpServices &
  ResendEmailsConfigurationsServices &
  DangerousDeletionServices &
  HolidayQuotesServices &
  HolidayQuotesXServices &
  QuoteTemplatesServices &
  BookingsServices &
  BookingActivityLogsServices &
  BookingDiscussionItemsServices &
  NotificationInboxServices &
  NotificationsServices &
  ExternalAccountsServices &
  BrandServices &
  SuppliersServices &
  CustomerPaymentMethodsServices &
  SupplierPaymentMethodsServices &
  AccountAuditLogsServices &
  AccountingBulkOperationsServices &
  LedgersServices &
  LedgerTransactionsServices &
  JournalEntriesServices &
  TrialBalanceServices &
  TradeExpensesServices &
  CustomerInvoicesServices &
  CustomerPaymentReceiptsServices &
  CustomerCreditVouchersServices &
  ProfitAllocationRecordsServices &
  SupplierBillsServices &
  SupplierBillPaymentReceiptsServices &
  BookingTransactionsServices &
  FlightSearchServices &
  ReconciliationServices &
  AccountingFlagsServices;

export const SDK = new MainService(SDKConfig) as any as iSDK;
